import { useApiClient } from '@commander/api-client';
import { useMutation } from '@tanstack/react-query';

interface SubmitFeedbackPayload {
  thread_id: string;
  message_ui_id: string;
  rating: 'positive' | 'negative';
  category?: string;
  app_context?: string;
}

export function useSubmitFeedback() {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: (data: SubmitFeedbackPayload) =>
      apiClient.post<{ success: boolean; id: string }>('/commander-go/feedback', data),
    onError: (error: Error) => {
      console.error('Failed to persist feedback:', error);
    },
  });
}

interface DeleteFeedbackPayload {
  thread_id: string;
  message_ui_id: string;
}

export function useDeleteFeedback() {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: ({ thread_id, message_ui_id }: DeleteFeedbackPayload) =>
      apiClient.delete<{ success: boolean }>(
        `/commander-go/feedback/${thread_id}/${encodeURIComponent(message_ui_id)}`
      ),
    onError: (error: Error) => {
      console.error('Failed to delete feedback:', error);
    },
  });
}
